export const settingsTranslationsEn = {
  title: 'Settings',
  subtitle: 'Manage your profile and preferences',
  profile: 'Profile',
  userManagement: 'User Management',
  preferences: 'Preferences',
  companyProfile: 'Company Profile',
  companyName: 'Company Name',
  email: 'Email',
  phone: 'Phone Number',
  passwordSecurity: 'Password & Security',
  passwordSecurityDesc: 'Change your sign-in password for this account.',
  passwordSecurityMethodsHint: 'Use your current password or request a code by email or phone.',
  verificationMethod: 'Verify with',
  currentPasswordOption: 'Current password',
  currentPasswordOptionDescription: 'Use your existing password to approve the change immediately.',
  emailOtpOption: 'Email verification code',
  emailOtpOptionDescription: 'Send a one-time code to the email address on this account.',
  phoneOtpOption: 'Phone verification code',
  phoneOtpOptionDescription: 'Send a one-time code to the phone number on this account.',
  currentPassword: 'Current Password',
  currentPasswordPlaceholder: 'Enter your current password',
  otpCode: 'Verification Code',
  otpCodePlaceholder: 'Enter the 6-digit code',
  emailOtpCodeDescription: 'Request a code, then enter it here to confirm the password change.',
  phoneOtpCodeDescription: 'Request a code, then enter it here to confirm the password change.',
  codeDestination: 'Code destination',
  sendCode: 'Send Code',
  sendingCode: 'Sending...',
  newPassword: 'New Password',
  newPasswordPlaceholder: 'Enter your new password',
  confirmNewPassword: 'Confirm New Password',
  confirmNewPasswordPlaceholder: 'Re-enter your new password',
  changePassword: 'Change Password',
  changingPassword: 'Changing...',
  otpSentTitle: 'Verification code sent',
  otpSendErrorTitle: 'Could not send code',
  otpSendErrorMessage: 'We could not send a verification code. Please try again.',
  passwordChangeSuccessTitle: 'Password updated',
  passwordChangeSuccessMessage: 'Your password has been changed successfully.',
  changePasswordErrorTitle: 'Password change failed',
  changePasswordErrorMessage: 'We could not update your password. Please try again.',
  saveChanges: 'Save Changes',
  deleteAccount: 'Delete Account',
  deleteAccountDesc: 'This action permanently removes your account access. Please contact support if this was accidental.',
  deleteAccountDialogTitle: 'Delete account permanently?',
  deleteAccountDialogDesc: 'This cannot be undone. Your account access and related profile data will be removed.',
  deleteAccountReasonLabel: 'Reason (optional)',
  deleteAccountReasonPlaceholder: 'Tell us why you are deleting this account',
  deleteAccountConfirm: 'Yes, delete account',
  deletingAccount: 'Deleting...',
  cancel: 'Cancel',
  teamMembers: 'Team Members',
  inviteUser: 'Invite User',
  active: 'Active',
  invited: 'Invited',
  roles: {
    admin: 'Administrator',
    manager: 'Manager',
    viewer: 'Viewer',
  },
  userManagementNoTenantTitle: 'Tenant Not Found',
  userManagementNoTenantDesc: 'Your account is not linked to a tenant, so user management is unavailable.',
  userManagementNoAccessTitle: 'No Access',
  userManagementNoAccessDesc: 'Only customer admins can create and manage tenant users.',
  language: 'Language',
  languageDesc: 'Choose the language used across the portal.',
  theme: 'Theme',
  themeDesc: 'Select a visual theme for the portal.',
  light: 'Light',
  dark: 'Dark',
  validation: {
    currentPasswordRequired: 'Current password is required',
    newPasswordRequired: 'New password is required',
    confirmPasswordRequired: 'Please confirm your new password',
    otpCodeRequired: 'Verification code is required',
    otpCodeFormat: 'Verification code must be 6 digits',
    passwordMinLength: 'Password must be at least 6 characters',
    passwordMaxLength: 'Password must be 100 characters or less',
    passwordsMismatch: 'Passwords do not match',
  },
} as const

export const settingsTranslationsAr = {
  title: 'الإعدادات',
  subtitle: 'إدارة ملفك الشخصي وتفضيلاتك',
  profile: 'الملف الشخصي',
  userManagement: 'إدارة المستخدمين',
  preferences: 'التفضيلات',
  companyProfile: 'ملف الشركة',
  companyName: 'اسم الشركة',
  email: 'البريد الإلكتروني',
  phone: 'رقم الهاتف',
  passwordSecurity: 'كلمة المرور والأمان',
  passwordSecurityDesc: 'غيّر كلمة مرور تسجيل الدخول لهذا الحساب.',
  passwordSecurityMethodsHint: 'استخدم كلمة المرور الحالية أو اطلب رمزًا عبر البريد الإلكتروني أو الهاتف.',
  verificationMethod: 'التحقق باستخدام',
  currentPasswordOption: 'كلمة المرور الحالية',
  currentPasswordOptionDescription: 'استخدم كلمة المرور الحالية للموافقة على التغيير مباشرة.',
  emailOtpOption: 'رمز تحقق عبر البريد الإلكتروني',
  emailOtpOptionDescription: 'أرسل رمزًا لمرة واحدة إلى البريد الإلكتروني المرتبط بهذا الحساب.',
  phoneOtpOption: 'رمز تحقق عبر الهاتف',
  phoneOtpOptionDescription: 'أرسل رمزًا لمرة واحدة إلى رقم الهاتف المرتبط بهذا الحساب.',
  currentPassword: 'كلمة المرور الحالية',
  currentPasswordPlaceholder: 'أدخل كلمة المرور الحالية',
  otpCode: 'رمز التحقق',
  otpCodePlaceholder: 'أدخل الرمز المكون من 6 أرقام',
  emailOtpCodeDescription: 'اطلب رمزًا ثم أدخله هنا لتأكيد تغيير كلمة المرور.',
  phoneOtpCodeDescription: 'اطلب رمزًا ثم أدخله هنا لتأكيد تغيير كلمة المرور.',
  codeDestination: 'وجهة الرمز',
  sendCode: 'إرسال الرمز',
  sendingCode: 'جارٍ الإرسال...',
  newPassword: 'كلمة المرور الجديدة',
  newPasswordPlaceholder: 'أدخل كلمة المرور الجديدة',
  confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
  confirmNewPasswordPlaceholder: 'أعد إدخال كلمة المرور الجديدة',
  changePassword: 'تغيير كلمة المرور',
  changingPassword: 'جارٍ التغيير...',
  otpSentTitle: 'تم إرسال رمز التحقق',
  otpSendErrorTitle: 'تعذر إرسال الرمز',
  otpSendErrorMessage: 'تعذر إرسال رمز التحقق. يرجى المحاولة مرة أخرى.',
  passwordChangeSuccessTitle: 'تم تحديث كلمة المرور',
  passwordChangeSuccessMessage: 'تم تغيير كلمة المرور بنجاح.',
  changePasswordErrorTitle: 'فشل تغيير كلمة المرور',
  changePasswordErrorMessage: 'تعذر تحديث كلمة المرور. يرجى المحاولة مرة أخرى.',
  saveChanges: 'حفظ التغييرات',
  deleteAccount: 'حذف الحساب',
  deleteAccountDesc: 'هذا الإجراء يحذف وصول حسابك بشكل دائم. يرجى التواصل مع الدعم إذا كان هذا بالخطأ.',
  deleteAccountDialogTitle: 'حذف الحساب نهائيًا؟',
  deleteAccountDialogDesc: 'لا يمكن التراجع عن هذا الإجراء. سيتم حذف وصول الحساب وبيانات الملف المرتبطة به.',
  deleteAccountReasonLabel: 'السبب (اختياري)',
  deleteAccountReasonPlaceholder: 'أخبرنا بسبب حذف هذا الحساب',
  deleteAccountConfirm: 'نعم، احذف الحساب',
  deletingAccount: 'جارٍ الحذف...',
  cancel: 'إلغاء',
  teamMembers: 'أعضاء الفريق',
  inviteUser: 'دعوة مستخدم',
  active: 'نشط',
  invited: 'تمت الدعوة',
  roles: {
    admin: 'مسؤول',
    manager: 'مدير',
    viewer: 'مستعرض',
  },
  userManagementNoTenantTitle: 'لم يتم العثور على مستأجر',
  userManagementNoTenantDesc: 'حسابك غير مرتبط بمستأجر، لذلك إدارة المستخدمين غير متاحة.',
  userManagementNoAccessTitle: 'لا توجد صلاحية',
  userManagementNoAccessDesc: 'فقط مسؤولو العملاء يمكنهم إنشاء وإدارة مستخدمي المستأجر.',
  language: 'اللغة',
  languageDesc: 'اختر اللغة المستخدمة في البوابة.',
  theme: 'المظهر',
  themeDesc: 'اختر المظهر المناسب للبوابة.',
  light: 'فاتح',
  dark: 'داكن',
  validation: {
    currentPasswordRequired: 'كلمة المرور الحالية مطلوبة',
    newPasswordRequired: 'كلمة المرور الجديدة مطلوبة',
    confirmPasswordRequired: 'يرجى تأكيد كلمة المرور الجديدة',
    otpCodeRequired: 'رمز التحقق مطلوب',
    otpCodeFormat: 'يجب أن يتكون رمز التحقق من 6 أرقام',
    passwordMinLength: 'يجب أن تتكون كلمة المرور من 6 أحرف على الأقل',
    passwordMaxLength: 'يجب ألا تزيد كلمة المرور عن 100 حرف',
    passwordsMismatch: 'كلمات المرور غير متطابقة',
  },
} as const

export const settingsTranslationsUr = {
  title: 'ترتیبات',
  subtitle: 'اپنا پروفائل اور ترجیحات منظم کریں',
  profile: 'پروفائل',
  userManagement: 'صارفین کا نظم',
  preferences: 'ترجیحات',
  companyProfile: 'کمپنی پروفائل',
  companyName: 'کمپنی کا نام',
  email: 'ای میل',
  phone: 'فون نمبر',
  passwordSecurity: 'پاس ورڈ اور سیکیورٹی',
  passwordSecurityDesc: 'اس اکاؤنٹ کے لیے اپنا سائن اِن پاس ورڈ تبدیل کریں۔',
  passwordSecurityMethodsHint: 'اپنا موجودہ پاس ورڈ استعمال کریں یا ای میل یا فون پر کوڈ منگوائیں۔',
  verificationMethod: 'تصدیق کا طریقہ',
  currentPasswordOption: 'موجودہ پاس ورڈ',
  currentPasswordOptionDescription: 'تبدیلی کی فوری تصدیق کے لیے اپنا موجودہ پاس ورڈ استعمال کریں۔',
  emailOtpOption: 'ای میل تصدیقی کوڈ',
  emailOtpOptionDescription: 'اس اکاؤنٹ کے ای میل پتے پر ایک وقتی کوڈ بھیجیں۔',
  phoneOtpOption: 'فون تصدیقی کوڈ',
  phoneOtpOptionDescription: 'اس اکاؤنٹ کے فون نمبر پر ایک وقتی کوڈ بھیجیں۔',
  currentPassword: 'موجودہ پاس ورڈ',
  currentPasswordPlaceholder: 'اپنا موجودہ پاس ورڈ درج کریں',
  otpCode: 'تصدیقی کوڈ',
  otpCodePlaceholder: '6 ہندسوں کا کوڈ درج کریں',
  emailOtpCodeDescription: 'پہلے کوڈ منگوائیں، پھر پاس ورڈ تبدیلی کی تصدیق کے لیے اسے یہاں درج کریں۔',
  phoneOtpCodeDescription: 'پہلے کوڈ منگوائیں، پھر پاس ورڈ تبدیلی کی تصدیق کے لیے اسے یہاں درج کریں۔',
  codeDestination: 'کوڈ کی منزل',
  sendCode: 'کوڈ بھیجیں',
  sendingCode: 'بھیجا جا رہا ہے...',
  newPassword: 'نیا پاس ورڈ',
  newPasswordPlaceholder: 'اپنا نیا پاس ورڈ درج کریں',
  confirmNewPassword: 'نئے پاس ورڈ کی تصدیق کریں',
  confirmNewPasswordPlaceholder: 'اپنا نیا پاس ورڈ دوبارہ درج کریں',
  changePassword: 'پاس ورڈ تبدیل کریں',
  changingPassword: 'تبدیل کیا جا رہا ہے...',
  otpSentTitle: 'تصدیقی کوڈ بھیج دیا گیا',
  otpSendErrorTitle: 'کوڈ نہیں بھیجا جا سکا',
  otpSendErrorMessage: 'ہم تصدیقی کوڈ نہیں بھیج سکے۔ دوبارہ کوشش کریں۔',
  passwordChangeSuccessTitle: 'پاس ورڈ اپ ڈیٹ ہو گیا',
  passwordChangeSuccessMessage: 'آپ کا پاس ورڈ کامیابی سے تبدیل ہو گیا۔',
  changePasswordErrorTitle: 'پاس ورڈ تبدیل نہیں ہو سکا',
  changePasswordErrorMessage: 'آپ کا پاس ورڈ اپ ڈیٹ نہیں ہو سکا۔ دوبارہ کوشش کریں۔',
  saveChanges: 'تبدیلیاں محفوظ کریں',
  deleteAccount: 'اکاؤنٹ حذف کریں',
  deleteAccountDesc: 'یہ عمل آپ کے اکاؤنٹ کی رسائی مستقل طور پر ختم کر دے گا۔ اگر یہ غلطی سے ہوا ہے تو سپورٹ سے رابطہ کریں۔',
  deleteAccountDialogTitle: 'اکاؤنٹ مستقل طور پر حذف کریں؟',
  deleteAccountDialogDesc: 'یہ عمل واپس نہیں ہو سکتا۔ آپ کے اکاؤنٹ کی رسائی اور متعلقہ پروفائل ڈیٹا حذف ہو جائے گا۔',
  deleteAccountReasonLabel: 'وجہ (اختیاری)',
  deleteAccountReasonPlaceholder: 'بتائیں کہ آپ یہ اکاؤنٹ کیوں حذف کر رہے ہیں',
  deleteAccountConfirm: 'ہاں، اکاؤنٹ حذف کریں',
  deletingAccount: 'حذف کیا جا رہا ہے...',
  cancel: 'منسوخ کریں',
  teamMembers: 'ٹیم ممبران',
  inviteUser: 'صارف کو مدعو کریں',
  active: 'فعال',
  invited: 'مدعو کردہ',
  roles: {
    admin: 'ایڈمن',
    manager: 'منیجر',
    viewer: 'ناظر',
  },
  userManagementNoTenantTitle: 'ٹیننٹ نہیں ملا',
  userManagementNoTenantDesc: 'آپ کا اکاؤنٹ کسی ٹیننٹ سے منسلک نہیں ہے، اس لیے صارف نظم دستیاب نہیں ہے۔',
  userManagementNoAccessTitle: 'رسائی نہیں',
  userManagementNoAccessDesc: 'صرف کسٹمر ایڈمنز ٹیننٹ صارفین کو بنا اور منظم کر سکتے ہیں۔',
  language: 'زبان',
  languageDesc: 'پورٹل میں استعمال ہونے والی زبان منتخب کریں۔',
  theme: 'تھیم',
  themeDesc: 'پورٹل کے لیے تھیم منتخب کریں۔',
  light: 'ہلکا',
  dark: 'گہرا',
  validation: {
    currentPasswordRequired: 'موجودہ پاس ورڈ درکار ہے',
    newPasswordRequired: 'نیا پاس ورڈ درکار ہے',
    confirmPasswordRequired: 'براہ کرم نئے پاس ورڈ کی تصدیق کریں',
    otpCodeRequired: 'تصدیقی کوڈ درکار ہے',
    otpCodeFormat: 'تصدیقی کوڈ 6 ہندسوں کا ہونا چاہیے',
    passwordMinLength: 'پاس ورڈ کم از کم 6 حروف کا ہونا چاہیے',
    passwordMaxLength: 'پاس ورڈ 100 حروف سے زیادہ نہیں ہو سکتا',
    passwordsMismatch: 'پاس ورڈ میل نہیں کھاتے',
  },
} as const
